import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import { AverageCalls, DashboardSearchProps } from "../../../../domain/repositories/dashboard.repository";
import DateDto from "../../../dto/date.dto";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const getCallAveragesApiImpl = async (_: DashboardSearchProps): Promise<Either<ErrorEntity, {
    completed: AverageCalls,
    failed: AverageCalls,
    notRated: AverageCalls,
    totalCalls?: number,
}>> => {
    try {
        let relativeUrl = "/stats/call-detail?";
        const { startDate, endDate, aiAgentId, callTypeId, humanAgentId, operationId }: { startDate: Date, endDate: Date, operationId?: string, humanAgentId?: string, aiAgentId?: string, callTypeId?: string, } = _;
        if (startDate) relativeUrl += `start_date=${DateDto.toServer(startDate)}&`
        if (endDate) relativeUrl += `end_date=${DateDto.toServer(endDate)}&`
        if (aiAgentId) relativeUrl += `agent_id=${aiAgentId}&`
        if (callTypeId) relativeUrl += `call_type=${callTypeId}&`
        if (humanAgentId) relativeUrl += `human_agent_id=${humanAgentId}&`
        if (operationId) relativeUrl += `operation_id=${operationId}&`
        relativeUrl = relativeUrl.slice(0, -1); // remove the last '&'
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        const toTwoDigits = (num: number): number => Number(num.toFixed(2));
        const parser = (name: string): AverageCalls => {
            const av = response.filter((it: any) => it.job_status.toLowerCase() == name)?.at(0);
            return {
                calls: av ? toTwoDigits(av.avg_call_score) : 0,
                agent: av ? toTwoDigits(av.avg_agent_score) : 0,
                customer: av ? toTwoDigits(av.avg_customer_score) : 0,
                total: av?.total_calls ?? 0
            }
        }
        const parsed = {
            completed: parser("completed"),
            failed: parser("failed"),
            notRated: parser("not_rated"),
            totalCalls: 0,
        }
        parsed.totalCalls = parsed.completed.total + parsed.failed.total + parsed.notRated.total;
        return right(parsed);

    } catch (error) {
        console.error("Error in getCallAveragesApiImpl", error);
        return left(ErrorEntity.fromError(error));
    }
}

export default getCallAveragesApiImpl;